import type { CatalogState } from './product-catalog.reducer';
import { WEBSITE_CATALOG_FEATURE_KEY } from './product-catalog.reducer';
import type { WebsiteState } from '../website-feature.reducer';

import { createSelector } from '@ngrx/store';
import { websiteState } from '../website-state.selectors';
import type { CatalogProductCard } from '@web/widgets/product-card/type/product-card-widget.type';
import { type CatalogCategory } from '@web/widgets/product-card/type/product-card-widget.type';

export const selectCatalogState = createSelector(
    websiteState,
    (state: WebsiteState): CatalogState => state[WEBSITE_CATALOG_FEATURE_KEY]
);

export const selectCategories = createSelector(
    selectCatalogState,
    (state: CatalogState): CatalogCategory[] => state?.categories
);

export const selectProducts = createSelector(
    selectCatalogState,
    (state: CatalogState): CatalogProductCard[] => state?.products
);

export const selectSelectedCategory = createSelector(
    selectCatalogState,
    (state: CatalogState): number => state?.selectedCategory
);

export const selectIsLoading = createSelector(selectCatalogState, (state: CatalogState): boolean => state?.isLoading);

export const selectIsTariffExpired = createSelector(selectCatalogState, (state: CatalogState): boolean =>
    Boolean(state?.isTariffExpired)
);

export const selectTotal = createSelector(selectCatalogState, (state: CatalogState): number => state?.total);
